module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJpY29uX2Rhc2hwb2ludCI+DQo8cGF0aCBpZD0iUmVjdGFuZ2xlIDI3MiIgb3BhY2l0eT0iMC4zIiBkPSJNMTUuMDQwOSAwTDE1LjIxOTIgNC4yNzE0TDIuNDA2NTIgMTYuMDc5NEwyLjIyODI1IDExLjgwOEwxNS4wNDA5IDBaIiBmaWxsPSIjMDBGRkZGIi8+DQo8cGF0aCBpZD0iUmVjdGFuZ2xlIDI3MyIgb3BhY2l0eT0iMC4xNSIgZD0iTTE3LjU5MzQgMy45MjA5TDE3Ljc3MTYgOC4xOTIzTDQuOTU5MDEgMjAuMDAwM0w0Ljc4MDc1IDE1LjcyODlMMTcuNTkzNCAzLjkyMDlaIiBmaWxsPSIjMDBGRkZGIi8+DQo8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_dashpoint.svg
// module id = Mop+
// module chunks = 1